import React, { Component } from "react";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

const HomeUserDescription = (props) => {
  return (
    <Card style={{ width: "18rem" }}>
      <Card.Body className="d-flex flex-column">
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.description}</Card.Text>
        <div className="mt-auto">
          <Link to={props.link} role="button" className="btn btn-primary">
            {props.buttonName}
          </Link>
        </div>
      </Card.Body>
    </Card>
  );
};

export default HomeUserDescription;
